import { render } from "./legal-video.vue?vue&type=template&id=22c7b2c9&scoped=true"
import script from "./legal-video.vue?vue&type=script&lang=js"
export * from "./legal-video.vue?vue&type=script&lang=js"

import "./legal-video.vue?vue&type=style&index=0&id=22c7b2c9&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c7b2c9"]])

export default __exports__